import React, { useState, useEffect } from 'react';
import {
    Grid,
    Button,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Box,
    TablePagination
} from '@material-ui/core';
import { useDispatch } from 'react-redux';

// Icons
import SearchIcon from '@material-ui/icons/Search';

import translation from "../../i18n/i18.json"
import useStyles from "./HistoryManagement.css"
import AllActions from '../../actions';
import { InforDisplyaDuration, MasterDataConstants } from '../../constants/AppConstants';
import { MasterDataService } from '../../services/MasterDataService';
import { HistoryFilters } from '../../models/Master/HistoryFilters';
import { RequestHistory } from '../../models/Master/RequestHistory';
import { ApprovalHistory } from '../../models/Master/ApprovalHistory';

const TabPanel = (props: any) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`mat-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {value === index && children}
                </Box>
            )}
        </div>
    );
}

export default function HistoryManagement() {
    const classes = useStyles();
    const dispatch = useDispatch();

    const INITIAL_FILTERS = {
        requestHistoryType: 1,
        requestNo: "",
        timeZone: new Date().getTimezoneOffset()
    }

    const [filterParams, setFilterParams] = useState<HistoryFilters>(INITIAL_FILTERS);
    const [reqHistoryTablePage, setReqHistoryTablePage] = React.useState(0);
    const [approvalHistoryTablePage, setApprovalHistoryTablePage] = React.useState(0);
    const [reqHistoryTableRowData, setReqHistoryTableRowData] = useState<RequestHistory[]>([]);
    const [approvalHistoryTableRowData, setApprovalHistoryTableRowData] = useState<ApprovalHistory[]>([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(MasterDataConstants.TablerowCount);
    const [isTableLoading, setIsTableLoading] = React.useState(false);


    const reqHistoryTableColumnData = [
        { name: translation.vendor_detail_basic_name_lbl },
        { name: translation.vendor_detail_basic_bsnature_lbl },
        { name: translation.vendor_detail_basic_vntitle_lbl },
        { name: translation.vendor_detail_basic_purpsepaymnt_lbl },
        { name: translation.vendor_detail_basic_bsregnumber_lbl },
        { name: translation.vendor_detail_basic_nic_lbl },
        { name: translation.vendor_detail_contactdetails_addnum_lbl },
        { name: translation.vendor_detail_contactdetails_poscode_lbl },
        { name: translation.vendor_detail_contactdetails_city_lbl },
        { name: translation.vendor_detail_contactdetails_country_lbl },
        { name: translation.vendor_detail_contactdetails_regncd_lbl },
        { name: translation.vendor_detail_contactdetails_contctforpay_lbl },
        { name: translation.vendor_detail_contactdetails_contctperdes_lbl },
        /* { name: translation.vendor_detail_contactdetails_tel_lbl }, */
       /*  { name: translation.vendor_detail_contactdetails_email_lbl }, */
        { name: translation.vendor_detail_contactdetails_website_lbl },
        { name: translation.vendor_detail_contactdetails_commetod_lbl },
        { name: translation.vendor_detail_paymentdetails_isforensup_lbl },
        { name: translation.vendor_detail_paymentdetails_termtrd_lbl },
        { name: translation.vendor_detail_paymentdetails_paymethod_lbl },
        { name: translation.vendor_detail_paymentdetails_credperiod_lbl },
       /*  { name: translation.vendor_detail_paymentdetails_currencyst_lbl }, */
        { name: translation.vendor_detail_paymentdetails_vatreg_lbl },
        { name: translation.vendor_detail_paymentdetails_svatreg_lbl },
        { name: translation.vendor_detail_paymentdetails_svattype_lbl },
        { name: translation.vendor_detail_paymentdetails_svatcontctper_connum_lbl },
        { name: translation.vendor_detail_paymentdetails_svatcontctper_email_lbl },
        { name: translation.vendor_detail_paymentdetails_vatno_lbl },
        { name: translation.vendor_detail_paymentdetails_svatno_lbl },
        { name: translation.vendor_detail_paymentdetails_tinnic_lbl },
        { name: translation.vendor_detail_paymentdetails_1099_lbl },
        { name: translation.vendor_detail_paymentdetails_taxconperson_lbl },
        { name: translation.vendor_detail_paymentdetails_taxconperdetl_lbl },
        { name: translation.vendor_detail_paymentdetails_lforwht_lbl },
        { name: translation.vendor_detail_paymentdetails_whtcountry_lbl },
        { name: translation.vendor_detail_paymentdetails_whttype_lbl },
        { name: translation.vendor_detail_paymentdetails_whtcode_lbl },
        { name: translation.vendor_detail_paymentdetails_exempnum_lbl },
        { name: translation.vendor_detail_paymentdetails_exemp_lbl },
        { name: translation.vendor_detail_paymentdetails_exempfrm_lbl },
        { name: translation.vendor_detail_paymentdetails_exempto_lbl },
        { name: translation.vendor_detail_paymentdetails_des_lbl },
        { name: translation.vendor_detail_paymentdetails_forgentryreq_lbl },
        { name: translation.vendor_detail_paymentdetails_avdoubltax_lbl },
        { name: translation.vendor_detail_paymentdetails_taxrate_lbl },
        { name: translation.vendor_detail_paymentdetails_pannum_lbl },
        { name: translation.vendor_detail_paymentdetails_taxnum_lbl },
        { name: translation.vendor_detail_bankdetails_bacontnm_lbl },
        { name: translation.vendor_detail_bankdetails_badress_lbl },
        { name: translation.vendor_detail_bankdetails_bankacnum_lbl },
        { name: translation.vendor_detail_bankdetails_bankkey_lbl },
        { name: translation.vendor_detail_bankdetails_accurency_lbl },
        { name: translation.vendor_detail_bankdetails_bankname_lbl },
        { name: translation.vendor_detail_bankdetails_bankad_lbl },
        { name: translation.vendor_detail_bankdetails_sorcode_lbl },
        { name: translation.vendor_detail_bankdetails_swiftcd_lbl },
        { name: translation.vendor_detail_bankdetails_ibancode_lbl },
        { name: translation.vendor_detail_bankdetails_bankbranch_lbl },
        { name: translation.vendor_detail_bankdetails_cbidcode_lbl },
        { name: translation.vendor_detail_bankdetails_inskey_lbl },
        { name: translation.vendor_detail_bankdetails_housebank_lbl },
        { name: translation.vendor_detail_bankdetails_reconac_lbl },
        { name: translation.vendor_detail_bankdetails_purposecode_lbl },
        { name: translation.vendor_detail_bankdetails_accounclk_lbl },
        { name: translation.vendor_detail_bankdetails_accounemail_lbl },

    ];

    const approveHistoryTableColumnData = [
        { name: 'Approval Point' },
        { name: 'Status' },
        { name: 'Approval/Rejection Comments' },
        { name: 'Approver' },
        { name: 'Approved Date' },
        { name: 'Approved Time' },
    ]

    useEffect(() => {
        setReqHistoryTablePage(0)
        setApprovalHistoryTablePage(0)
        setFilterParams(INITIAL_FILTERS)
        setReqHistoryTableRowData([])
        setApprovalHistoryTableRowData([])
    }, [])

    useEffect(() => {
        if (isTableLoading) {
            setReqHistoryTablePage(0)
            setApprovalHistoryTablePage(0)
            getHistoryData();
        }
    }, [isTableLoading])

    const prepareForRequest = () => {
        dispatch(AllActions.backDropActions.openBackDrop());
    };

    const compeleteRequest = (success: boolean, message?: string) => {
        dispatch(AllActions.backDropActions.closeBackDrop());
        if (message) {
            if (success) {
                dispatch(AllActions.infoActions.openInforSuccess(message, InforDisplyaDuration.common));
            } else {
                dispatch(AllActions.infoActions.openInforError(message, InforDisplyaDuration.common));
            }
        }
    };

    const getHistoryData = () => {
        prepareForRequest();
        MasterDataService.getHistoryData(
            filterParams,
            function (data: any) {
                if (filterParams.requestHistoryType == 1) {
                    setReqHistoryTableRowData(data.result || []);
                }
                if (filterParams.requestHistoryType == 2) {
                    setApprovalHistoryTableRowData(data.result.result || []);
                }

                compeleteRequest(true);
                setIsTableLoading(false);
            },
            function (error: Error) {
                if (filterParams.requestHistoryType == 1) {
                    setReqHistoryTableRowData([]);
                }
                if (filterParams.requestHistoryType == 2) {
                    setApprovalHistoryTableRowData([]);
                }
                compeleteRequest(false, translation.master_user_list_error);
                setIsTableLoading(false);
            }
        );
    }

    const handleChange = (input: string) => (e: any) => {
        let val: any = e.target.value;
        setFilterParams({ ...filterParams!, [input]: val });
    }

    const onTabsChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setFilterParams({ ...filterParams, requestHistoryType: newValue + 1 });
        if (!!filterParams.requestNo) {
            setIsTableLoading(true);
        }

    }

    // handle pagination page change event
    const reqTableHandleChangePage = (event: unknown, newPage: number) => {
        setReqHistoryTablePage(newPage);
    };

    // handle pagination page change event
    const approvalTableHandleChangePage = (event: unknown, newPage: number) => {
        setApprovalHistoryTablePage(newPage);
    };

    return (
        <React.Fragment>
              <Grid
          container
          spacing={2}
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.createHeader}
        >
          <span className={classes.createHeaderTxt}>
          {translation.main_menu_history_mangemnet}
          </span>
          {/* <span className={classes.createHeaderLine}></span> */}
        </Grid>
            {/* Filters */}
            <Grid
                container
                spacing={2}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className={classes.filterheader}
            >
            <Grid
                container
                spacing={2}
                item
                xs={12}
                sm={12}
                md={1}
                lg={1}
                className={classes.filterheader}
            >
                Filter
            </Grid>
            <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
                <div className={classes.filterWrapper}>
                    <div className={classes.dataBlock}>
                        <label className={classes.filterLbl}>
                            {translation.master_history_req_no}
                        </label>
                        <div className={classes.inputWrapperFilter}>
                            <TextField
                                variant="outlined"
                                value={filterParams.requestNo}
                                onChange={handleChange("requestNo")}
                            ></TextField>
                        </div>
                    </div>
                    <div className={classes.dataBlock}>
                        <div className={classes.searchBtnWrapper}>
                            <Button onClick={() => setIsTableLoading(true)} style={{ float: "left" }}>
                                <SearchIcon>
                                </SearchIcon>{translation.dashboard_filternm_btntxt}
                            </Button>
                        </div>
                    </div>
                </div>
            </Grid>
            </Grid>
            {/* Tabs */}
            <Tabs value={filterParams.requestHistoryType - 1} onChange={onTabsChange}>
                <Tab label="Vendor History" tabIndex={0} />
                <Tab label="Approval History" tabIndex={1} />
            </Tabs>
            <div className={classes.tblOuterBG}>
                {/* Tabs Content */}
                <TabPanel value={filterParams.requestHistoryType - 1} index={0}>
                    <TableContainer className={classes.tblContainer}>
                        <Table size="small" stickyHeader aria-label="sticky table">
                            <TableHead className={classes.tblHeader}>
                                <TableRow>
                                    {
                                        reqHistoryTableColumnData.map((column, index) => {
                                            return <TableCell style={{ minWidth: "200px" }}>{column.name}</TableCell>;
                                        })
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody className={classes.tblBody}>
                                {
                                    reqHistoryTableRowData.slice(reqHistoryTablePage * rowsPerPage, reqHistoryTablePage * rowsPerPage + rowsPerPage).map((row, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell>{row.vendorName}</TableCell>
                                                <TableCell>{row.natureOfbusiness}</TableCell>
                                                <TableCell>{row.title}</TableCell>
                                                <TableCell>{row.purposePayment}</TableCell>
                                                <TableCell>{row.busRegNumber}</TableCell>
                                                <TableCell>{row.vendorNic}</TableCell>
                                                <TableCell>{row.addressNumberStreet}</TableCell>
                                                <TableCell>{row.addressPostalCode}</TableCell>
                                                <TableCell>{row.addressCity}</TableCell>
                                                <TableCell>{row.addressCoutry}</TableCell>
                                                <TableCell>{row.regionCode}</TableCell>
                                                <TableCell>{row.paymentContactPersonName}</TableCell>
                                                <TableCell>{row.paymentContactPersonDesig}</TableCell>
                                                {/* <TableCell>??</TableCell> */}{/* Mob ?? */}
                                               {/*  <TableCell>??</TableCell> */}{/* EMAIL?NOTE ?? */}
                                                <TableCell>{row.companyWebSite}</TableCell>
                                                <TableCell>{row.prefCommunMethod}</TableCell>
                                                <TableCell>{row.isForeignSupplier}</TableCell>
                                                <TableCell>{row.termsOfTrade}</TableCell>
                                                <TableCell>{row.prefPayMethod}</TableCell>
                                                <TableCell>{row.creditPeriodDays}</TableCell>
                                                {/* <TableCell>??</TableCell> */}{/* SETTLEMENT CURRENCY ? */}
                                                <TableCell>{row.vatRegisterd}</TableCell>
                                                <TableCell>{row.svatRegistered}</TableCell>
                                                <TableCell>{row.svatType}</TableCell>
                                                <TableCell>{row.svatContactNumber}</TableCell>
                                                <TableCell>{row.svatContactEmail}</TableCell>
                                                <TableCell>{row.vatNumber}</TableCell>
                                                <TableCell>{row.svatNumber}</TableCell>
                                                <TableCell>{row.tinNic}</TableCell>
                                                <TableCell>{row.tax1099}</TableCell>
                                                <TableCell>{row.taxConPersnName}</TableCell>
                                                <TableCell>{row.taxConPersnConNum}</TableCell>
                                                <TableCell>{row.liableForWHT}</TableCell>
                                                <TableCell>{row.whtCountry}</TableCell>
                                                <TableCell>{row.whtType}</TableCell>
                                                <TableCell>{row.whtCode}</TableCell>
                                                <TableCell>{row.exemptionNumber}</TableCell>
                                                <TableCell>{row.exemption}</TableCell>
                                                <TableCell>{row.exemptFrom}</TableCell>
                                                <TableCell>{row.exemptTo}</TableCell>
                                                <TableCell>{row.discription}</TableCell>
                                                <TableCell>{row.foreignEntityReq}</TableCell>
                                                <TableCell>{row.availabilityDT}</TableCell>
                                                <TableCell>{row.taxRateDT}</TableCell>
                                                <TableCell>{row.panNumber}</TableCell>
                                                <TableCell>{row.taxNumber}</TableCell>
                                                <TableCell>{row.beneficiaryAccName}</TableCell>
                                                <TableCell>{row.beneficiaryAddress}</TableCell>
                                                <TableCell>{row.bankAccNumber}</TableCell>
                                                <TableCell>{row.bankACKey}</TableCell>
                                                <TableCell>{row.accCurrency}</TableCell>
                                                <TableCell>{row.bankName}</TableCell>
                                                <TableCell>{row.bankAddress}</TableCell>
                                                <TableCell>{row.sortCode}</TableCell>
                                                <TableCell>{row.swiftCode}</TableCell>
                                                <TableCell>{row.ibanCode}</TableCell>
                                                <TableCell>{row.bankNumber}</TableCell>
                                                <TableCell>{row.cbidCode}</TableCell>
                                                <TableCell>{row.instructionKey}</TableCell>
                                                <TableCell>{row.houseBank}</TableCell>
                                                <TableCell>{row.reconAC}</TableCell>
                                                <TableCell>{row.purposeCode}</TableCell>
                                                <TableCell>{row.accoutingClark}</TableCell>
                                                <TableCell>{row.accoutingEmail}</TableCell>
                                            </TableRow>
                                        )
                                    }
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[MasterDataConstants.TablerowCount]}
                        component="div"
                        count={reqHistoryTableRowData.length}
                        rowsPerPage={rowsPerPage}
                        page={reqHistoryTablePage}
                        onPageChange={reqTableHandleChangePage}
                    />
                </TabPanel>
                <TabPanel value={filterParams.requestHistoryType - 1} index={1}>
                    <TableContainer className={classes.tblContainer}>
                        <Table size="small" stickyHeader aria-label="sticky table">
                            <TableHead className={classes.tblHeader}>
                                <TableRow>
                                    {
                                        approveHistoryTableColumnData.map((column, index) => {
                                            return <TableCell style={{ minWidth: "200px" }}>{column.name}</TableCell>;
                                        })
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody className={classes.tblBody}>
                                {
                                    approvalHistoryTableRowData.slice(approvalHistoryTablePage * rowsPerPage, approvalHistoryTablePage * rowsPerPage + rowsPerPage).map((row, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell>{row.approvalPoint}</TableCell>
                                                <TableCell>{row.status}</TableCell>
                                                <TableCell>{row.reasonForRejection}</TableCell>
                                                <TableCell>{row.approver}</TableCell>
                                                <TableCell>{row.approvedDate}</TableCell>
                                                <TableCell>{row.approvedTime}</TableCell>
                                            </TableRow>
                                        )
                                    }
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[MasterDataConstants.TablerowCount]}
                        component="div"
                        count={approvalHistoryTableRowData.length}
                        rowsPerPage={rowsPerPage}
                        page={approvalHistoryTablePage}
                        onPageChange={approvalTableHandleChangePage}
                    />
                </TabPanel>
            </div>
        </React.Fragment>
    )
}